import axios from "axios";
import {
  CREATE_CARE_PLAN_FAIL,
  CREATE_CARE_PLAN_REQUEST,
  CREATE_CARE_PLAN_SUCCESS,
  CREATE_GOAL_PLAN_FAIL,
  CREATE_GOAL_PLAN_REQUEST,
  CREATE_GOAL_PLAN_SUCCESS,
  CREATE_MEDICATION_PLAN_FAIL,
  CREATE_MEDICATION_PLAN_REQUEST,
  CREATE_MEDICATION_PLAN_SUCCESS,
  CREATE_PLAN_ASSESSMENT_FAIL,
  CREATE_PLAN_ASSESSMENT_REQUEST,
  CREATE_PLAN_ASSESSMENT_SUCCESS,
  CREATE_PLAN_INTERVENTION_FAIL,
  CREATE_PLAN_INTERVENTION_REQUEST,
  CREATE_PLAN_INTERVENTION_SUCCESS,
  CREATE_PLAN_MEMBER_FAIL,
  CREATE_PLAN_MEMBER_REQUEST,
  CREATE_PLAN_MEMBER_SUCCESS,
  CREATE_PLAN_PROBLEM_FAIL,
  CREATE_PLAN_PROBLEM_REQUEST,
  CREATE_PLAN_PROBLEM_SUCCESS,
  CREATE_PLAN_SOCIAL_CONTEXT_FAIL,
  CREATE_PLAN_SOCIAL_CONTEXT_REQUEST,
  CREATE_PLAN_SOCIAL_CONTEXT_SUCCESS,
  EDIT_GOAL_PLAN_FAIL,
  EDIT_GOAL_PLAN_REQUEST,
  EDIT_GOAL_PLAN_SUCCESS,
  EDIT_MEDICATION_PLAN_FAIL,
  EDIT_MEDICATION_PLAN_REQUEST,
  EDIT_MEDICATION_PLAN_SUCCESS,
  EDIT_PLAN_INTERVENTION_FAIL,
  EDIT_PLAN_INTERVENTION_REQUEST,
  EDIT_PLAN_INTERVENTION_SUCCESS,
  EDIT_PLAN_MEMBER_FAIL,
  EDIT_PLAN_MEMBER_REQUEST,
  EDIT_PLAN_MEMBER_SUCCESS,
  EDIT_PLAN_PROBLEM_FAIL,
  EDIT_PLAN_PROBLEM_REQUEST,
  EDIT_PLAN_PROBLEM_SUCCESS,
  EDIT_PLAN_SOCIAL_CONTEXT_FAIL,
  EDIT_PLAN_SOCIAL_CONTEXT_REQUEST,
  EDIT_PLAN_SOCIAL_CONTEXT_SUCCESS,
  GET_CARE_PLAN_FAIL,
  GET_CARE_PLAN_REQUEST,
  GET_CARE_PLAN_SUCCESS,
  GET_CARE_PLAN_SUMMARY_FAIL,
  GET_CARE_PLAN_SUMMARY_REQUEST,
  GET_CARE_PLAN_SUMMARY_SUCCESS,
  GET_PLAN_ASSESSMENT_FAIL,
  GET_PLAN_ASSESSMENT_REQUEST,
  GET_PLAN_ASSESSMENT_SUCCESS,
  GET_PLAN_GOALS_LIST_FAIL,
  GET_PLAN_GOALS_LIST_REQUEST,
  GET_PLAN_GOALS_LIST_SUCCESS,
  GET_PLAN_INTERVENTIONS_LIST_FAIL,
  GET_PLAN_INTERVENTIONS_LIST_REQUEST,
  GET_PLAN_INTERVENTIONS_LIST_SUCCESS,
  GET_PLAN_MEDICATIONS_LIST_FAIL,
  GET_PLAN_MEDICATIONS_LIST_REQUEST,
  GET_PLAN_MEDICATIONS_LIST_SUCCESS,
  GET_PLAN_MEMBERS_LIST_FAIL,
  GET_PLAN_MEMBERS_LIST_REQUEST,
  GET_PLAN_MEMBERS_LIST_SUCCESS,
  GET_PLAN_PROBLEMS_LIST_FAIL,
  GET_PLAN_PROBLEMS_LIST_REQUEST,
  GET_PLAN_PROBLEMS_LIST_SUCCESS,
  GET_PLAN_SOCIAL_CONTEXT_FAIL,
  GET_PLAN_SOCIAL_CONTEXT_REQUEST,
  GET_PLAN_SOCIAL_CONTEXT_SUCCESS,
  GET_PLAN_VERSIONS_LIST_FAIL,
  GET_PLAN_VERSIONS_LIST_REQUEST,
  GET_PLAN_VERSIONS_LIST_SUCCESS,
  RESET_CREATE_CARE_PLAN,
  RESET_CREATE_GOAL_PLAN,
  RESET_CREATE_MEDICATION_PLAN,
  RESET_CREATE_PLAN_ASSESSMENT,
  RESET_CREATE_PLAN_INTERVENTION,
  RESET_CREATE_PLAN_MEMBER,
  RESET_CREATE_PLAN_PROBLEM,
  RESET_CREATE_PLAN_SOCIAL_CONTEXT,
  RESET_EDIT_GOAL_PLAN,
  RESET_EDIT_MEDICATION_PLAN,
  RESET_EDIT_PLAN_INTERVENTION,
  RESET_EDIT_PLAN_MEMBER,
  RESET_EDIT_PLAN_PROBLEM,
  RESET_EDIT_PLAN_SOCIAL_CONTEXT,
  RESET_SAVE_PLAN_VERSION,
  RESET_UPDATE_PLAN_ASSESSMENT,
  SAVE_PLAN_VERSION_FAIL,
  SAVE_PLAN_VERSION_REQUEST,
  SAVE_PLAN_VERSION_SUCCESS,
  SET_EDIT_CARE_PLAN,
  UPDATE_PLAN_ASSESSMENT_FAIL,
  UPDATE_PLAN_ASSESSMENT_REQUEST,
  UPDATE_PLAN_ASSESSMENT_SUCCESS,
} from "../../assets/constants/carePlanConstants";
import { apiRequest } from "../../utils/helpers/api";

// ================   EDIT CARE PLAN =========================
export const editCarePlanFunc = (isEdit) => (dispatch) =>
  dispatch({
    type: SET_EDIT_CARE_PLAN,
    payload: isEdit,
  });

// ================== CREATE CARE PLAN =========================
export const createCarePlanFunc = (carePlanObj) => async (dispatch) => {
  dispatch({ type: CREATE_CARE_PLAN_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/care-plan/create`,
    data: carePlanObj,
  });

  if (data) {
    dispatch({ type: CREATE_CARE_PLAN_SUCCESS, payload: data });
  } else {
    dispatch({ type: CREATE_CARE_PLAN_FAIL, payload: error });
  }
};

export const resetCreateCarePlan = () => async (dispatch) => {
  dispatch({ type: RESET_CREATE_CARE_PLAN });
};

// ================== GET CARE PLAN =========================
export const getCarePlanFunc = (id) => async (dispatch) => {
  dispatch({ type: GET_CARE_PLAN_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/care-plan/list`,
    params: { patient_id: id, exclude_child_entities: true },
  });

  if (data) {
    dispatch({ type: GET_CARE_PLAN_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_CARE_PLAN_FAIL, payload: error });
  }
  // try {
  //   dispatch({ type: GET_CARE_PLAN_REQUEST });

  //   const token = Cookies.get("token");
  //   if (token) {
  //     const config = {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     };

  //     const response = await axios.get(
  //       `${BASE_URL}/care-plan/list?patient_id=${id}`,
  //       config
  //     );

  //     if (!response?.data?.ok) {
  //       throw new Error(response?.data?.message);
  //     }

  //     dispatch({
  //       type: GET_CARE_PLAN_SUCCESS,
  //       payload: response?.data,
  //     });
  //   }
  // } catch (error) {
  //   dispatch({
  //     type: GET_CARE_PLAN_FAIL,
  //     payload:
  //       error.response && error.response.data.message
  //         ? error.response.data.message
  //         : error.message,
  //   });
  // }
};

// ================== GET CARE PLAN SUMMARY =========================
export const getCarePlanSummaryFunc = (summaryObj) => async (dispatch) => {
  dispatch({ type: GET_CARE_PLAN_SUMMARY_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/care-plan/summary`,
    params: summaryObj,
  });

  if (data) {
    dispatch({ type: GET_CARE_PLAN_SUMMARY_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_CARE_PLAN_SUMMARY_FAIL, payload: error });
  }
};

// ================== GET CARE PLAN ASESSMENT =========================
export const getPlanAssessmentFunc = (carePlanId) => async (dispatch) => {
  dispatch({ type: GET_PLAN_ASSESSMENT_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/care-plan-assessment/get`,
    params: { care_plan_id: carePlanId },
  });

  if (data) {
    dispatch({ type: GET_PLAN_ASSESSMENT_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_PLAN_ASSESSMENT_FAIL, payload: error });
  }
};

// ================== GET PLAN VERSIONS LIST =========================
export const getPlanVersionsListFunc = (care_plan_id) => async (dispatch) => {
  dispatch({ type: GET_PLAN_VERSIONS_LIST_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/care-plan-version/list`,
    params: { care_plan_id },
  });

  if (data) {
    dispatch({ type: GET_PLAN_VERSIONS_LIST_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_PLAN_VERSIONS_LIST_FAIL, payload: error });
  }
};

// ================== CREATE CARE PLAN ASSESSMENT =========================
export const createPlanAssesmentFunc = (assessmentObj) => async (dispatch) => {
  dispatch({ type: CREATE_PLAN_ASSESSMENT_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/care-plan-assessment/create`,
    data: assessmentObj,
  });

  if (data) {
    dispatch({ type: CREATE_PLAN_ASSESSMENT_SUCCESS, payload: data });
  } else {
    dispatch({ type: CREATE_PLAN_ASSESSMENT_FAIL, payload: error });
  }
};

export const resetCreatePlanAssessment = () => async (dispatch) => {
  dispatch({ type: RESET_CREATE_PLAN_ASSESSMENT });
};

// ================== UPDATE CARE PLAN ASSESSMENT =========================
export const updatePlanAssessmentFunc = (assessmentObj) => async (dispatch) => {
  dispatch({ type: UPDATE_PLAN_ASSESSMENT_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/care-plan-assessment/update`,
    data: assessmentObj,
  });

  if (data) {
    dispatch({ type: UPDATE_PLAN_ASSESSMENT_SUCCESS, payload: data });
  } else {
    dispatch({ type: UPDATE_PLAN_ASSESSMENT_FAIL, payload: error });
  }
};

export const resetUpdatePlanAssessment = () => async (dispatch) => {
  dispatch({ type: RESET_UPDATE_PLAN_ASSESSMENT });
};

// ================== CREATE PLAN PROBLEM =========================
export const createPlanProblemFunc = (problemObj) => async (dispatch) => {
  dispatch({ type: CREATE_PLAN_PROBLEM_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/care-plan-problem/create`,
    data: problemObj,
  });

  if (data) {
    dispatch({ type: CREATE_PLAN_PROBLEM_SUCCESS, payload: data });
  } else {
    dispatch({ type: CREATE_PLAN_PROBLEM_FAIL, payload: error });
  }
};

export const resetCreatePlanProblem = () => async (dispatch) => {
  dispatch({ type: RESET_CREATE_PLAN_PROBLEM });
};

// ==================GET PLAN PROBLEMS LIST =========================
export const getPlanProblemsListFunc = (carePlanId) => async (dispatch) => {
  dispatch({ type: GET_PLAN_PROBLEMS_LIST_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/care-plan-problem/list`,
    params: { care_plan_id: carePlanId },
  });

  if (data) {
    dispatch({ type: GET_PLAN_PROBLEMS_LIST_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_PLAN_PROBLEMS_LIST_FAIL, payload: error });
  }
};

// EDIT PLAN PROBLEM =========================
export const editPlanProblemFunc = (problemObj) => async (dispatch) => {
  dispatch({ type: EDIT_PLAN_PROBLEM_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/care-plan-problem/update`,
    data: problemObj,
  });

  if (data) {
    dispatch({ type: EDIT_PLAN_PROBLEM_SUCCESS, payload: data });
  } else {
    dispatch({ type: EDIT_PLAN_PROBLEM_FAIL, payload: error });
  }
};

export const resetEditPlanProblem = () => async (dispatch) => {
  dispatch({ type: RESET_EDIT_PLAN_PROBLEM });
};

// ================== CREATE GOAL PLAN =========================
export const createGoalPlanFunc = (goalObj) => async (dispatch) => {
  dispatch({ type: CREATE_GOAL_PLAN_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/care-plan-goal/create`,
    data: goalObj,
  });

  if (data) {
    dispatch({ type: CREATE_GOAL_PLAN_SUCCESS, payload: data });
  } else {
    dispatch({ type: CREATE_GOAL_PLAN_FAIL, payload: error });
  }
};

// ==================GET PLAN GOALS LIST =========================
export const getPlanGoalsListFunc = (carePlanId) => async (dispatch) => {
  dispatch({ type: GET_PLAN_GOALS_LIST_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/care-plan-goal/list`,
    params: { care_plan_id: carePlanId },
  });

  if (data) {
    dispatch({ type: GET_PLAN_GOALS_LIST_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_PLAN_GOALS_LIST_FAIL, payload: error });
  }
};

// ================== EDIT GOAL PLAN =========================
export const editGoalPlanFunc = (goalObj) => async (dispatch) => {
  dispatch({ type: EDIT_GOAL_PLAN_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/care-plan-goal/update`,
    data: goalObj,
  });

  if (data) {
    dispatch({ type: EDIT_GOAL_PLAN_SUCCESS, payload: data });
  } else {
    dispatch({ type: EDIT_GOAL_PLAN_FAIL, payload: error });
  }
};

export const resetGoalPlan = () => async (dispatch) => {
  dispatch({ type: RESET_CREATE_GOAL_PLAN });
};

export const resetEditGoalPlan = () => async (dispatch) => {
  dispatch({ type: RESET_EDIT_GOAL_PLAN });
};

// ================== CREATE PLAN INTERVENTION =========================
export const createPlanInterventionFunc =
  (interventionObj) => async (dispatch) => {
    dispatch({ type: CREATE_PLAN_INTERVENTION_REQUEST });

    const { data, error } = await apiRequest({
      method: "post",
      url: `/care-plan-intervention/create`,
      data: interventionObj,
    });

    if (data) {
      dispatch({ type: CREATE_PLAN_INTERVENTION_SUCCESS, payload: data });
    } else {
      dispatch({ type: CREATE_PLAN_INTERVENTION_FAIL, payload: error });
    }
  };

export const resetCreatePlanIntervention = () => async (dispatch) => {
  dispatch({ type: RESET_CREATE_PLAN_INTERVENTION });
};

// ==================GET PLAN INTERVENTIONS LIST =========================
export const getPlanInterventionsListFunc =
  (carePlanId) => async (dispatch) => {
    dispatch({ type: GET_PLAN_INTERVENTIONS_LIST_REQUEST });

    const { data, error } = await apiRequest({
      method: "get",
      url: `/care-plan-intervention/list`,
      params: { care_plan_id: carePlanId },
    });

    if (data) {
      dispatch({ type: GET_PLAN_INTERVENTIONS_LIST_SUCCESS, payload: data });
    } else {
      dispatch({ type: GET_PLAN_INTERVENTIONS_LIST_FAIL, payload: error });
    }
  };

// ================== EDIT PLAN INTERVENTION =========================
export const editPlanInterventionFunc =
  (interventionObj) => async (dispatch) => {
    dispatch({ type: EDIT_PLAN_INTERVENTION_REQUEST });

    const { data, error } = await apiRequest({
      method: "post",
      url: `/care-plan-intervention/update`,
      data: interventionObj,
    });

    if (data) {
      dispatch({ type: EDIT_PLAN_INTERVENTION_SUCCESS, payload: data });
    } else {
      dispatch({ type: EDIT_PLAN_INTERVENTION_FAIL, payload: error });
    }
  };

export const resetEditPlanIntervention = () => async (dispatch) => {
  dispatch({ type: RESET_EDIT_PLAN_INTERVENTION });
};

// ================== CREATE MEDICATION PLAN  =========================
export const createMedicationPlanFunc = (medicationObj) => async (dispatch) => {
  dispatch({ type: CREATE_MEDICATION_PLAN_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/care-plan-medication/create`,
    data: medicationObj,
  });

  if (data) {
    dispatch({ type: CREATE_MEDICATION_PLAN_SUCCESS, payload: data });
  } else {
    dispatch({ type: CREATE_MEDICATION_PLAN_FAIL, payload: error });
  }
};

export const resetCreateMedicationPlan = () => async (dispatch) => {
  dispatch({ type: RESET_CREATE_MEDICATION_PLAN });
};

// ==================GET PLAN MEDICATIONS LIST =========================
export const getPlanMedicationsListFunc = (carePlanId) => async (dispatch) => {
  dispatch({ type: GET_PLAN_MEDICATIONS_LIST_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/care-plan-medication/list`,
    params: { care_plan_id: carePlanId },
  });

  if (data) {
    dispatch({ type: GET_PLAN_MEDICATIONS_LIST_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_PLAN_MEDICATIONS_LIST_FAIL, payload: error });
  }
};

// ================== EDIT MEDICATION PLAN  =========================
export const editMedicationPlanFunc = (medicationObj) => async (dispatch) => {
  dispatch({ type: EDIT_MEDICATION_PLAN_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/care-plan-medication/update`,
    data: medicationObj,
  });

  if (data) {
    dispatch({ type: EDIT_MEDICATION_PLAN_SUCCESS, payload: data });
  } else {
    dispatch({ type: EDIT_MEDICATION_PLAN_FAIL, payload: error });
  }
};

export const resetEditMedicationPlan = () => async (dispatch) => {
  dispatch({ type: RESET_EDIT_MEDICATION_PLAN });
};

// ================== CREATE PLAN MEMBER =========================
export const createPlanMemberFunc = (memberObj) => async (dispatch) => {
  dispatch({ type: CREATE_PLAN_MEMBER_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/care-team-member/create`,
    data: memberObj,
  });

  if (data) {
    dispatch({ type: CREATE_PLAN_MEMBER_SUCCESS, payload: data });
  } else {
    dispatch({ type: CREATE_PLAN_MEMBER_FAIL, payload: error });
  }
};

export const resetCreatePlanMember = () => async (dispatch) => {
  dispatch({ type: RESET_CREATE_PLAN_MEMBER });
};

// ==================GET PLAN MEMBERS LIST =========================
export const getPlanMembersListFunc = (carePlanId) => async (dispatch) => {
  dispatch({ type: GET_PLAN_MEMBERS_LIST_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/care-team-member/list`,
    params: { care_plan_id: carePlanId },
  });

  if (data) {
    dispatch({ type: GET_PLAN_MEMBERS_LIST_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_PLAN_MEMBERS_LIST_FAIL, payload: error });
  }
};

// ================== EDIT PLAN MEMBER =========================
export const editPlanMemberFunc = (memberObj) => async (dispatch) => {
  dispatch({ type: EDIT_PLAN_MEMBER_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/care-team-member/update`,
    data: memberObj,
  });

  if (data) {
    dispatch({ type: EDIT_PLAN_MEMBER_SUCCESS, payload: data });
  } else {
    dispatch({ type: EDIT_PLAN_MEMBER_FAIL, payload: error });
  }
};

export const resetEditPlanMember = () => async (dispatch) => {
  dispatch({ type: RESET_EDIT_PLAN_MEMBER });
};

// ================== CREATE PLAN SOCIAL CONTEXT =========================
export const createPlanSocialContextFunc =
  (socialContextObj) => async (dispatch) => {
    dispatch({ type: CREATE_PLAN_SOCIAL_CONTEXT_REQUEST });

    const { data, error } = await apiRequest({
      method: "post",
      url: `/care-plan-social-context/create`,
      data: socialContextObj,
    });

    if (data) {
      dispatch({ type: CREATE_PLAN_SOCIAL_CONTEXT_SUCCESS, payload: data });
    } else {
      dispatch({ type: CREATE_PLAN_SOCIAL_CONTEXT_FAIL, payload: error });
    }
  };

export const resetCreatePlanSocialContext = () => async (dispatch) => {
  dispatch({ type: RESET_CREATE_PLAN_SOCIAL_CONTEXT });
};

// ==================GET PLAN MEMBERS LIST =========================
export const getPlanSocialContextFunc = (carePlanId) => async (dispatch) => {
  dispatch({ type: GET_PLAN_SOCIAL_CONTEXT_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/care-plan-social-context/get`,
    params: { care_plan_id: carePlanId },
  });

  if (data) {
    dispatch({ type: GET_PLAN_SOCIAL_CONTEXT_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_PLAN_SOCIAL_CONTEXT_FAIL, payload: error });
  }
};

// ================== EDIT PLAN SOCIAL CONTEXT =========================
export const editPlanSocialContextFunc =
  (socialContextObj) => async (dispatch) => {
    dispatch({ type: EDIT_PLAN_SOCIAL_CONTEXT_REQUEST });

    const { data, error } = await apiRequest({
      method: "post",
      url: `/care-plan-social-context/update`,
      data: socialContextObj,
    });

    if (data) {
      dispatch({ type: EDIT_PLAN_SOCIAL_CONTEXT_SUCCESS, payload: data });
    } else {
      dispatch({ type: EDIT_PLAN_SOCIAL_CONTEXT_FAIL, payload: error });
    }
  };

export const resetEditPlanSocialContext = () => async (dispatch) => {
  dispatch({ type: RESET_EDIT_PLAN_SOCIAL_CONTEXT });
};

// ================== SAVE PLAN VERSION CONTEXT =========================
export const savePlanVersionFunc = (versionObj) => async (dispatch) => {
  dispatch({ type: SAVE_PLAN_VERSION_REQUEST });

  const { data, error } = await apiRequest({
    method: "post",
    url: `/care-plan-version/approve`,
    data: versionObj,
  });

  if (data) {
    dispatch({ type: SAVE_PLAN_VERSION_SUCCESS, payload: data });
  } else {
    dispatch({ type: SAVE_PLAN_VERSION_FAIL, payload: error });
  }
};

export const resetSavePlanVersion = () => async (dispatch) => {
  dispatch({ type: RESET_SAVE_PLAN_VERSION });
};
